import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../common-data/Converts";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";

const WPTemplateListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const {
    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,
  } = useSelector((state) => state.blog);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      !broadcastWPTemplatesLoading &&
      !broadcastWPTemplatesError &&
      broadcastWPTemplates?.status &&
      broadcastWPTemplates?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: broadcastWPTemplates.data,
        pagination:
          broadcastWPTemplates?.pagination?.length > 0
            ? broadcastWPTemplates.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [
    broadcastWPTemplates,
    broadcastWPTemplatesLoading,
    broadcastWPTemplatesError,
  ]);

  const tbColumns = [
    {
      dataField: "elementName",
      text: "template name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.elementName?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category",
      text: "category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category || "NA"}</span>;
      },
    },
    {
      dataField: "body",
      text: "body",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.body ? (
              <b
                className="link"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "description",
                    rowData: row,
                  }))
                }>
                read
              </b>
            ) : (
              "NA"
            )}
          </span>
        );
      },
    },
    {
      dataField: "customParams",
      text: "variables",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.customParams?.length > 0 ? "link" : ""}`}
            onClick={() =>
              row?.customParams?.length > 0
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "variables",
                    rowData: row,
                  }))
                : null
            }>
            {row?.customParams?.length || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background: row?.status === "APPROVED" ? "#0A701B" : "#D90000",
              color: "#fff",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "lastModified",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.lastModified ? formatDateTime(row.lastModified) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
      {broadcastWPTemplatesLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default WPTemplateListings;
